import { supabase } from '../lib/supabase';

export interface TTSOptions {
  text: string;
  voiceId?: string;
  modelId?: string;
}

// Calls backend TTS and returns a signed URL to short-lived audio
export async function requestTTS({ text, voiceId, modelId }: TTSOptions): Promise<string> {
  if (!text || typeof text !== 'string') throw new Error('text is required');
  const { data: sessionData } = await supabase.auth.getSession();
  const token = sessionData?.session?.access_token;
  const userId = sessionData?.session?.user?.id;
  const resp = await fetch('/api/voice/tts', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ userId, text, voiceId, modelId }),
  });
  if (!resp.ok) {
    const status = resp.status;
    let msg = 'TTS request failed';
    try { const j = await resp.json(); if (j?.error) msg = j.error; } catch {}
    if (status === 401) throw new Error('Not authenticated');
    if (status === 403) throw new Error('Premium subscription or trial required');
    throw new Error(msg);
  }
  const j = await resp.json();
  const url2 = j?.url as string | undefined;
  if (!url2) throw new Error('No audio URL returned');
  return url2;
}

